export default __webpack_public_path__ + "media/images/Masto-A1-coeur-pattes-feb4a720f06becade74cece87ce681d1.png";